/**  Типы пластиковых карт. */
export enum CardsPlasticTypes {
  /** Неизвестный. */
  Unknow = 0,

  /** VISA  - код 4. */
  Visa = 1,

  /** MASTER CARD - код 5. */
  MasterCard = 2,

  /** MIR (МИР) - код 2. */
  Mir = 3,

  /** CHINA CARD - код 6. */
  CUP = 4
}
